import { useMetricClickHandler } from "../shared/useMetricClickHandler";
import { FinanceLabField } from "@/entities/FinanceLab";
import { useAtomValue } from "jotai";
import { projectedFinancialsMetricsAtom } from "../../metrics.state";

export function useProjectedFinancialsData() {
    const handleMetricClick = useMetricClickHandler();
    const projectedFinancialsMetrics = useAtomValue(
        projectedFinancialsMetricsAtom,
    );

    const getYearValue = (
        metricValues: { period: string; formattedValue?: string }[] | undefined,
        year: string,
    ): string => {
        if (!metricValues) return "-";
        const yearData = metricValues.find((item) => item.period === year);
        return yearData?.formattedValue || "-";
    };

    const projectedRevenueMetric =
        projectedFinancialsMetrics[
            FinanceLabField
                .ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_TOTAL_REVENUE
        ];

    const projectedGrossMarginMetric =
        projectedFinancialsMetrics[
            FinanceLabField
                .ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_GROSS_MARGIN_P
        ];

    const projectedEbitdaMetric =
        projectedFinancialsMetrics[
            FinanceLabField
                .ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_EBITDA
        ];

    const projectedEbitdaMarginMetric =
        projectedFinancialsMetrics[
            FinanceLabField
                .ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_EBITDA_MARGIN_P
        ];

    const projectedCashMetric =
        projectedFinancialsMetrics[
            FinanceLabField
                .ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_CASH
        ];

    const projectedSalesMarketingEfficiencyMetric =
        projectedFinancialsMetrics[
            FinanceLabField
                .ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_SALES_AND_MARKETING_EFFICIENCY
        ];

    return [
        {
            metric: "Revenue",
            "2026": getYearValue(projectedRevenueMetric?.values, "2026"),
            "2027": getYearValue(projectedRevenueMetric?.values, "2027"),
            "2028": getYearValue(projectedRevenueMetric?.values, "2028"),
            onClick: () => handleMetricClick(projectedRevenueMetric, "Revenue"),
        },
        {
            metric: "Gross Margin %",
            "2026": getYearValue(projectedGrossMarginMetric?.values, "2026"),
            "2027": getYearValue(projectedGrossMarginMetric?.values, "2027"),
            "2028": getYearValue(projectedGrossMarginMetric?.values, "2028"),
            onClick: () =>
                handleMetricClick(projectedGrossMarginMetric, "Gross Margin %"),
        },
        {
            metric: "EBITDA",
            "2026": getYearValue(projectedEbitdaMetric?.values, "2026"),
            "2027": getYearValue(projectedEbitdaMetric?.values, "2027"),
            "2028": getYearValue(projectedEbitdaMetric?.values, "2028"),
            onClick: () => handleMetricClick(projectedEbitdaMetric, "EBITDA"),
        },
        {
            metric: "EBITDA Margin %",
            "2026": getYearValue(projectedEbitdaMarginMetric?.values, "2026"),
            "2027": getYearValue(projectedEbitdaMarginMetric?.values, "2027"),
            "2028": getYearValue(projectedEbitdaMarginMetric?.values, "2028"),
            onClick: () =>
                handleMetricClick(
                    projectedEbitdaMarginMetric,
                    "EBITDA Margin %",
                ),
        },
        {
            metric: "Cash Balance",
            "2026": getYearValue(projectedCashMetric?.values, "2026"),
            "2027": getYearValue(projectedCashMetric?.values, "2027"),
            "2028": getYearValue(projectedCashMetric?.values, "2028"),
            onClick: () =>
                handleMetricClick(projectedCashMetric, "Cash Balance"),
        },
        {
            metric: "Sales & Marketing Efficiency",
            "2026": getYearValue(
                projectedSalesMarketingEfficiencyMetric?.values,
                "2026",
            ),
            "2027": getYearValue(
                projectedSalesMarketingEfficiencyMetric?.values,
                "2027",
            ),
            "2028": getYearValue(
                projectedSalesMarketingEfficiencyMetric?.values,
                "2028",
            ),
            onClick: () =>
                handleMetricClick(
                    projectedSalesMarketingEfficiencyMetric,
                    "Sales & Marketing Efficiency",
                ),
        },
    ];
}
